import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Grid, TableCell, TableRow } from "@mui/material";
import { Colors } from "../../constants/Colors";
import Card from "../../components/Card";
import CustomTable from "../../components/Table";
import { useNavigate, useParams } from "react-router-dom";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { apiRequest } from "../../services/api-request";
import AddEditUser from "./add-edit-employees";
import { useForm, Controller } from "react-hook-form";
import SelectPicker from "../../components/SelectPicker";
import Pagination from "../../components/Pagination";
import CustomDialog from "../../components/ConfirmationModal";
import { useAppContext } from "../../context/AppContext";
import CustomInput from "../../components/Input";
import CustomButton from "../../components/Button";
import { debounce } from "lodash";
import { downloadFile, escapeCSVField } from "../../utilities/exportToCsv";
import {
  CSelect,
  CInput
} from '@coreui/react'

const dashboardHeader = [
  {
    id: 1,
    title: "S.No",
  },
  {
    id: 2,
    title: "Customer ID",
  },
  {
    id: 3,
    title: "Customer Details",
  },
  // {
  //   id: 4,
  //   title: "Customer Other Details",
  // },
  {
    id: 4,
    title: "Customer Location",
  },
  {
    id: 5,
    title: "Loan Officer Name",
  },
  {
    id: 6,
    title: "Circle",
  },
  {
    id: 7,
    title: "Regional Office",
  },
  {
    id: 8,
    title: "Branch",
  },
  {
    id: 9,
    title: "Total Animals",
  },
  {
    id: 10,
    title: "Actions",
  }
];

const MuzzleFarmer = () => {
  const { user = {} } = useAppContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const { userType } = useParams();
  const [openAceRequestModal, setOpenAceRequestModal] = useState({
    data: {},
    open: false,
  });
  const role = "Muzzle Users"
  const roleSingular = "Muzzle Users"

  const currentRole = user?.role?.code || null;
  const branch_id = user?.role?.branch_id || null;

  const [userList, setUserList] = useState({});
  const [currentAnitraUserState, setCurrentAnitraUserState] = useState({});

  const [userAnimalsCSV, setUserAnimalsCSV] = useState({
    data: [],
    loader: false,
  });

  const limit = 10;
  const [skip, setSkip] = useState(0);

  const [openUserModal, setOpenUserModal] = useState({
    open: false,
    data: [],
  });

  const [filters, setFilters] = useState({
      state_id: "",
      circle_id: "",
      regional_id: "",
      branch_id: "",
  });

  const [statesList, setStatesList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [regionalList, setRegionalList] = useState([]);
  const [branchList, setBranchList] = useState([]);

  useEffect(() => {
        getStates();
  }, []);

  const getStates = () => {
      apiRequest({
        url: `master/states`,
        method: "GET",
      })
      .then((res) => {
          setStatesList(res?.data);
      })
        .catch((err) => {
          alert(err?.response?.data?.message, "error");
      });
  };

  useEffect(() => {
      if (filters.state_id) {
          getCirlces(filters.state_id);
      }
  }, [filters.state_id]);

  const getCirlces = (state_id) => {
      apiRequest({
        url: "bank/get-circle-office?state_id="+state_id,
        method: "GET",
      })
      .then((res) => {
          setCircleList(res?.data);
          setFilters(prev => ({
              ...prev,
              circle_id: "",
              regional_id: "",
              branch_id: "",
          }));
      })
      .catch((err) => {
          alert(err?.response?.data?.message, "error");
      });
  };

  useEffect(() => {
      if (filters.circle_id) {
        getRegionals(filters.circle_id);
      }
  }, [filters.circle_id]);

  const getRegionals = (circle_id) => {
      apiRequest({
        url: "bank/get-regional-office?circle_id="+circle_id,
        method: "GET",
      })
      .then((res) => {
          setRegionalList(res?.data);
          setFilters(prev => ({
              ...prev,
              regional_id: "",
              branch_id: "",
          }));
      })
      .catch((err) => {
          alert(err?.response?.data?.message, "error");
      });
  };

  useEffect(() => {
      if (filters.regional_id) {
        getBranches(filters.regional_id);
      }
  }, [filters.regional_id]);

  const getBranches = (regional_id) => {
      apiRequest({
        url: "bank/get-branch?regional_id="+regional_id,
        method: "GET",
      })
      .then((res) => {
          setBranchList(res?.data);
          setFilters(prev => ({
              ...prev,
              branch_id: ""
          }));
      })
      .catch((err) => {
          alert(err?.response?.data?.message, "error");
      });
  };

  const handleChange = (field) => (e) => {
      const value = e.target.value;
      setFilters(prev => ({
          ...prev,
          [field]: value
      }));
  };

  useEffect(() => {
    getUsersByType(
      roleSingular,
      filters,
      skip
    );
  }, [roleSingular, filters, skip]);

  const getUsersByType = useCallback(
    (userType, filters, skip) => {
      filters = Object.fromEntries(
          Object.entries(filters).filter(([_, v]) => v)
      );
      const url = `bank/get-farmer`;
      const payload = {
        ...(filters.search && {
          searchText: filters?.search,
        }),
        ...(filters.state_id && {
          filter_state_id: filters.state_id,
        }),
        ...(filters.circle_id && {
          filter_circle_id: filters.circle_id,
        }),
        ...(filters.regional_id && {
          filter_regional_id: filters.regional_id,
        }),
        ...(filters?.branch_id && {
          filter_branch_id: filters.branch_id,
        }),
        limit: limit,
        skip: skip,
        currentRole: currentRole,
        branch_id: branch_id,
        sort_field: "_id",
        sort_order: "desc",
        search_fields: ["name", "mobile", "user_id"],
      };

      apiRequest({
        url,
        data: payload,
        method: "POST",
      })
        .then((res) => {
          if (res) {
            setUserList(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    []
  );

  const handleEdit = useCallback((data) => {
    setCurrentAnitraUserState(data);
    setOpenUserModal({ data: data, open: true });
  }, []);

  const handlePageChange = (pageNumber) => {
    const newSkip = (pageNumber - 1) * limit;
    setSkip(newSkip);
  };

  const TableDataUi = () => {
    return userList?.data?.length ? (
      userList?.data?.map((row, index) => (
        <TableRow
          key={row.id}
          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
        >
          <TableCell>
            <Typography
              fontFamily={"Poppins-Medium"}
              color={Colors.headerColor}
              fontSize={13}
              sx={{ textDecoration: "underline", cursor: "pointer" }}
            >
              {skip + index + 1}
            </Typography>
          </TableCell>

          <TableCell>
            <Typography
              fontFamily={"Poppins-Medium"}
              color={Colors.headerColor}
              fontSize={13}
            >
              {row.user_id}
            </Typography>
          </TableCell>

          <TableCell>
            <Typography
              fontFamily={"Poppins-Regular"}
              color={Colors.textColor}
              fontSize={12}
            >
              Name: {row?.farmer_data?.name ? row.farmer_data.name : "NA"}<br/>
              Mobile: {row?.farmer_data?.mobile ? row.farmer_data.mobile : "NA"}<br/>
              Email: {row?.farmer_data?.email ? row.farmer_data.email : "NA"}<br/>
              {/*Gender: {row?.farmer_data?.gender ? row.farmer_data.gender : "NA"}<br/>
              Owner Type: {row?.owner_type ? row.owner_type : "NA"}<br/>*/}
              {/*Social Status: {row?.social_status ? row?.social_status : "NA"}<br/>*/}
              {/*Landholding: {row?.landholding ? row?.landholding : "NA"}*/}
            </Typography>
          </TableCell>
          
          {/*<TableCell>
            <Typography
              fontFamily={"Poppins-Regular"}
              color={Colors.textColor}
              fontSize={12}
            >
                Customer's Association No: {row?.farmer_asso_num ? row.farmer_asso_num : "NA"}<br />
                Pourer No: {row?.pourer_mem ? row.pourer_mem : "NO"}<br />
                Below Poverty Line: {row?.below_pow_line ? row.below_pow_line : "NO"}<br />
                Village Institution: {row?.village_inst ? row.village_inst : "NA"}<br />
                Village Institution Type: {row?.village_inst_type ? row.village_inst_type : "NA"}<br />
                Afflicated Agency: {row?.affliated_agency ? row.affliated_agency : "NA"}<br />
                Number of Milch: {row?.no_of_milch_animal ? row.no_of_milch_animal : "0"}<br />
            </Typography>
          </TableCell>*/}

            <TableCell>
              <Typography
                fontFamily={"Poppins-Regular"}
                color={Colors.textColor}
                fontSize={12}
              >
                {/* {
                  ((row?.farmer_data?.hamlet_name + ", ") || '')+ 
                  ((row.farmer_data.village_name + ", ") || '') + 
                  ((row.farmer_data.mandal_name + ", ") || '') + 
                  ((row.farmer_data.district_name + ", ") || '')+ 
                  ((row.farmer_data.state_name + " - ") || '')+
                  ((row.farmer_data.pincode) || '')
                } */}
                State: {row?.farmer_data?.state_name ? row.farmer_data.state_name : "NA"}<br />
                District: {row?.farmer_data?.district_name ? row.farmer_data.district_name : "NA"}<br />
                Mandal: {row?.farmer_data?.mandal_name ? row.farmer_data.mandal_name : "NA"}<br />
                Village: {row?.farmer_data?.village_name ? row.farmer_data.village_name : "NA"}<br />
                {/*Hamlet: {row?.farmer_data?.hamlet_name ? row.farmer_data.hamlet_name : "NA"}<br />*/}
                Pincode: {row?.farmer_data?.pincode ? row.farmer_data.pincode : "NA"}<br />
                Address: {row?.farmer_data?.address ? row.farmer_data.address : "NA"}<br />
              </Typography>
            </TableCell>

         <TableCell>
            <Typography
              fontFamily={"Poppins-Regular"}
              color={Colors.textColor}
              fontSize={12}
            >
              {row.loan_officer_name}
            </Typography>
          </TableCell>

          <TableCell>
            <Typography
              fontFamily={"Poppins-Regular"}
              color={Colors.textColor}
              fontSize={12}
            >
              {row.circle}
            </Typography>
          </TableCell>
          
          <TableCell>
            <Typography
              fontFamily={"Poppins-Regular"}
              color={Colors.textColor}
              fontSize={12}
            >
              {row.regional}
            </Typography>
          </TableCell>

          <TableCell>
            <Typography
              fontFamily={"Poppins-Regular"}
              color={Colors.textColor}
              fontSize={12}
            >
              {row.branch_info}
            </Typography>
          </TableCell>   

          <TableCell>
            <Typography
              fontFamily={"Poppins-Regular"}
              color={Colors.textColor}
              fontSize={12}
            >
              {row.total_animals}
            </Typography>
          </TableCell>

          {/* <TableCell>
            <Typography
              fontFamily={"Poppins-Regular"}
              color={Colors.textColor}
              fontSize={12}
            >
              {row.email!="" ? row.email : "NA"}
            </Typography>
          </TableCell> */}

          <TableCell
            sx={{ cursor: "pointer" }}
          >

          <Box
            padding={"2px 8px"}
            textAlign={"center"}
            borderRadius={"12px"}
            border={"1px solid #59981A"}
            bgcolor={"#59981A"}
            onClick={() => {
              handleEdit(row);
              // setOpenUserModal({ data: row, open: true });
            }}
          >
            <Typography
              fontFamily={"Poppins-Regular"}
              fontSize={"12px"}
              color={"#fff"}
              bgcolor={"#59981A"}
            >
              {"Edit"}
            </Typography>
          </Box>

          <Box
            padding={"2px 8px"}
            textAlign={"center"}
            borderRadius={"12px"}
            border={"1px solid #bb0713"}
            bgcolor={"#bb0713"}
            style={{marginTop: '10px'}}
            onClick={() => {
              setOpenAceRequestModal({ data: row, open: true });
            }}
          >
            <Typography
              fontFamily={"Poppins-Regular"}
              fontSize={"12px"}
              color={"#fff"}
              bgcolor={"#bb0713"}
            >
              {"Delete"}
            </Typography>
          </Box>
        </TableCell>

        </TableRow>
      ))
    ) : (
      <>
        <TableRow
          key={"row.id"}
          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          rowS
        >
          <TableCell colSpan={8} align="center">
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Typography>No Data Available</Typography>
            </Box>
          </TableCell>
        </TableRow>
      </>
    );
  };

  const clearFilters = () => {
    setFilters({
      search: "",
      state_id: "",
      circle_id: "",
      regional_id: "",
      branch_id: "",
    });
    setCircleList([])
    setRegionalList([])
    setBranchList([])
  };

  useEffect(() => {
    // let headers = [
    //   "Id,User ID,Owner Type,Social Status,Landholding,Farmer Association Number,Pourer Member,Below Poverty Line,Village Institution,Village Institution Type,Affiliated Agency,No of Milch Animals,Mobile,OTP,Password,Name,Email,Address,Pincode,ID Type,ID Number,ID Front Path,ID Back Path,State ID,District ID,Mandal ID,Village ID,Hamlet ID,Location Latitude,Location Longitude,Date of Birth,Gender,State Name,District Name,Mandal Name,Village Name,Hamlet Name",
    // ];
    let headers = [
      "Id,User ID,Mobile,Name,Email,Address,Pincode,State Name,District Name,Mandal Name,Village Name,Total No of Animals",
    ];
  
    if (Array.isArray(userAnimalsCSV.data) && userAnimalsCSV.data.length > 0) {
      const partnersCSV = userAnimalsCSV.data.reduce((acc, user) => {
        const {
          _id,
          user_id,
          // farmer_asso_num,
          // pourer_mem,
          // below_pow_line,
          // village_inst,
          // village_inst_type,
          // affliated_agency,
          total_animals,
          farmer_data,
        } = user;
  
        const {
          mobile = "NA",
          name = "NA",
          email = "NA",
          address = "NA",
          pincode = "NA",
          state_name = "NA",
          district_name = "NA",
          mandal_name = "NA",
          village_name = "NA",
        } = farmer_data || {};
  
        acc.push(
          [
            escapeCSVField(_id),
            escapeCSVField(user_id),
            escapeCSVField(mobile),
            escapeCSVField(name),
            escapeCSVField(email),
            escapeCSVField(address),
            escapeCSVField(pincode),
            escapeCSVField(state_name),
            escapeCSVField(district_name),
            escapeCSVField(mandal_name),
            escapeCSVField(village_name),
            escapeCSVField(total_animals),
          ].join(",")
        );
  
        return acc;
      }, []);
  
      downloadFile({
        data: [...headers, ...partnersCSV].join("\n"),
        fileName: "BankCustomers.csv",
        fileType: "text/csv",
      });
    }
  }, [userAnimalsCSV]);  
  

  const exportToCsv = (userType) => {
    const payload = {
        ...(filters.search && {
          searchText: filters?.search,
        }),
        ...(filters.state_id && {
          filter_state_id: filters.state_id,
        }),
        ...(filters.circle_id && {
          filter_circle_id: filters.circle_id,
        }),
        ...(filters.regional_id && {
          filter_regional_id: filters.regional_id,
        }),
        ...(filters?.branch_id && {
          filter_branch_id: filters.branch_id,
        }),
        limit: 10000000,
        skip: 0,
        currentRole: currentRole,
        branch_id: branch_id,
        sort_field: "_id",
        sort_order: "desc",
        search_fields: ["name", "mobile", "user_id"],
    };
    apiRequest({
      url: "bank/get-farmer",
      method: "POST",
      data: payload,
    })
      .then((res) => {
        setUserAnimalsCSV({ data: res?.data, loader: true });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const acceptAceRequest = () => {
    apiRequest({
      url: `bank/delete-farmer/${openAceRequestModal.data.user_id}`,
      method: "DELETE",
    })
      .then((res) => {
        setOpenAceRequestModal({ open: false })
        getUsersByType(roleSingular, filters, skip)
        setOpenAceRequestModal({
          data: {},
          open: false,
        });
      })
      .catch((err) => {
        alert(err);
      });
  };

  return (
    <Box>
      <CustomDialog
        open={openUserModal.open}
        width={"500px"}
        onClose={() => setOpenUserModal({ open: false })}
        title={"Edit Farmer"}
      >
        <AddEditUser
          onCancel={() => setOpenUserModal({ open: false })}
          roleSingular={roleSingular}
          currentState={currentAnitraUserState}
          isEdit={Boolean(currentAnitraUserState?.user_id)}
          getUsersByType={() =>
            getUsersByType(roleSingular, filters, skip)
          }
        />
      </CustomDialog>

      <CustomDialog
        open={openAceRequestModal.open}
        onClose={() => setOpenAceRequestModal({ open: false })}
        width={"450px"}
        title={"Delete Farmer"}
      >
        <Box>
          <Typography fontSize={"14px"} fontFamily={"poppins"}>
            Are you sure you want to Delete this Farmer ?
          </Typography>

          <Box
            display={"flex"}
            alignItems={"end"}
            justifyContent={"flex-end"}
            width={"100%"}
            mt={2}
            gap={"12px"}
          >
            <Box width={"25%"}>
              <CustomButton
                variant={"outlined"}
                title={`No`}
                handleButtonClick={() =>
                  setOpenAceRequestModal({ open: false })
                }
                backgroundColor={Colors.white}
                textColor={Colors.headerColor}
                width={"100%"}
                height={34}
                borderColor={Colors.headerColor}
                textFontSize={14}
              />
            </Box>
            <Box width={"25%"}>
              <CustomButton
                title={`Yes`}
                backgroundColor={Colors.headerColor}
                textColor={Colors.white}
                width={"100%"}
                height={34}
                borderColor={Colors.headerColor}
                textFontSize={14}
                handleButtonClick={acceptAceRequest}
              />
            </Box>
          </Box>
        </Box>
      </CustomDialog>

      <Grid
        container
        alignItems={"center"}
        gap={"10px"}
        justifyContent={"space-between"}
      >
        <Grid item>
          <Typography
            fontFamily={"Poppins-Medium"}
            fontSize={20}
            color={Colors.textColor}
          >
            Customer List
          </Typography>
        </Grid>
        <Grid item spacing={2}>
          <Box display={"flex"} gap={"10px"}>
            <Box>
              {/* <CustomButton
                title={`Add Employees`}
                handleButtonClick={() => {setCurrentAnitraUserState({}); setOpenUserModal({ data: null, open: true })}}
                backgroundColor={Colors.headerColor}
                textColor={Colors.white}
                width={'auto'}
                height={34}
                textFontSize={14}
              /> */}
            </Box>
            <Box>
              <CustomButton
                title={`Export List`}
                handleButtonClick={() => exportToCsv(userType)}
                backgroundColor={Colors.headerColor}
                textColor={Colors.white}
                width={130}
                height={34}
                textFontSize={14}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box mt={2}>
        <Card>
          
          <div className="filters-wrapper-1">
              <div className="filter-input-wrapper">
                  <label className="filter-input-label">Search</label>
                  <CInput type="text" className="filter-input1" placeholder="Search Name, Mobile, ID" onChange={handleChange('search')} value={filters.search}/>
              </div>
              <div className="filter-input-wrapper">
                  <label className="filter-input-label">State</label>
                  <CSelect custom onChange={handleChange('state_id')} value={filters.state_id} className="filter-input">
                      <option value="">--Select State--</option>
                      {
                          statesList.map((e, key) => {
                              return <option key={key} value={e.id}>{e.display_name}</option>;
                          })
                      }
                  </CSelect>
              </div>
              <div className="filter-input-wrapper">
                  <label className="filter-input-label">Circle</label>
                  <CSelect custom onChange={handleChange('circle_id')} value={filters.circle_id} className="filter-input">
                      <option value="">--Select Circle--</option>
                      {
                          circleList.map((e, key) => {
                              return <option key={key} value={e.id}>{e.name}</option>;
                          })
                      }
                  </CSelect>
              </div>
              <div className="filter-input-wrapper">
                  <label className="filter-input-label">Regional Office</label>
                  <CSelect custom onChange={handleChange('regional_id')} value={filters.regional_id} className="filter-input">
                      <option value="">--Select Regional--</option>
                      {
                          regionalList.map((e, key) => {
                              return <option key={key} value={e.id}>{e.name}</option>;
                          })
                      }
                  </CSelect>
              </div>
              <div className="filter-input-wrapper">
                  <label className="filter-input-label">Branch</label>
                  <CSelect custom onChange={handleChange('branch_id')} value={filters.branch_id} className="filter-input">
                      <option value="">--Select Branch--</option>
                      {
                          branchList.map((e, key) => {
                              return <option key={key} value={e.id}>{e.name} ({e.code})</option>;
                          })
                      }
                  </CSelect>
              </div>
              <div className="filter-input-wrapper">
                <Grid item md={2} style={{marginTop:'15px'}}>
                  <CustomButton
                    handleButtonClick={() => clearFilters()}
                    backgroundColor={"#59981A"}
                    textColor={"#fff"}
                    title={"Clear"}
                    padding={"5px 15px"}
                  />
                </Grid>
              </div>
          </div>

          <Box mt={2}>
            <CustomTable
              headerData= {dashboardHeader}
              tableData={[]}
            >
              <TableDataUi setOpenUserModal={setOpenUserModal} />
            </CustomTable>
            <Box mt={2} display={"flex"} justifyContent={"right"}>
              {userList?.total_count > 1 && (
                <Pagination
                  totalCount={Number(userList?.total_count)}
                  skip={skip}
                  limit={limit}
                  onPageChange={handlePageChange}
                />
              )}
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default MuzzleFarmer;